import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useMemo, useState } from 'react';
interface StorePreviewContextInterface {
  preview: ReactNode[];
  setPreview: Dispatch<SetStateAction<ReactNode[]>>;
  singleItemMode: boolean;
  setSingleItemMode: Dispatch<SetStateAction<boolean>>;
  css: string;
  lightLectureCss: string;
}
export const StorePreviewContext = createContext<StorePreviewContextInterface | null>(null);
export const StorePreviewProvider = ({
  css,
  lightLectureCss,
  children
}: {
  css: string;
  lightLectureCss: string;
  children: ReactNode;
}) => {
  const [preview, setPreview] = useState<ReactNode[]>([]);
  const [singleItemMode, setSingleItemMode] = useState(false);
  const value = useMemo(() => ({
    preview,
    setPreview,
    singleItemMode,
    setSingleItemMode,
    css,
    lightLectureCss
  }), [preview, singleItemMode]);
  return <StorePreviewContext.Provider value={value}>{children}</StorePreviewContext.Provider>;
};
export const useStorePreviewContext = () => {
  const context = useContext(StorePreviewContext);
  if (!context) {
    throw new Error("useStorePreviewContext must be used within a StoreProvider");
  }
  return context;
};